// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  baseURL: '/st-app',
  appVersion: '202501'
};

/*
export const firebaseConfig = {
  // test
  apiKey: "AIzaSyD46poZQxnrbjp-jSa5NOatP58oMk0odWQ",
  authDomain: "sport-technologies-test.firebaseapp.com",
  databaseURL: "https://sport-technologies-test.firebaseio.com",
  storageBucket: "sport-technologies-test.appspot.com",
  messagingSenderId: "841615950314"
};
*/

//
export const firebaseConfig = {
  // production
  //
  apiKey: "AIzaSyBVrzAklKgGSWZi029CfFTdi24dxpzH-I0",
  authDomain: "sport-technologies-prod.firebaseapp.com",
  databaseURL: "https://sport-technologies-prod.firebaseio.com",
  projectId: "sport-technologies-prod",
  storageBucket: "sport-technologies-prod.appspot.com",
  messagingSenderId: "581143079214"
  //
};
//
